<template>
  <header class="g-catalogo__title">
    <h1 class="g-catalogo__title-header">
      {{ this.categoryName }}
    </h1>
    <div
        class="g-catalogo__title-description"
        v-if="category.description"
        v-html="category.description"
    ></div>
  </header>
</template>

<script>
export default {
  name: "CategoryHeader",
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    categoryName() {
      return this.category?.name;
    },
  }
}
</script>